import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import { sampleReducer } from "./sampleReducer";
import storage from "redux-persist/lib/storage";
import { createStudentReducer } from "./createStudentReducer";
import { pgReducer } from "./pgReducer";
import { putmeReducer } from "./putmeReducer";
import { directEntryReducer } from "./directEntryReducer";
import { jupebReducer } from "./jupebReducer";
import { partTimeReducer } from "./partTimeReducer";
import { menuItemsReducer } from "./menuItemsReducer";
import { impersonatorReducer } from "./impersonatorReducer";
import { supplementaryReducer } from "./supplementaryReducer";
import { firstYearHostelReducer } from "./firstYearHostelReducer";

const persistConfig = {
	key: "root",
	storage,
	whitelist: [
		"studentData",
		"pgData",
		"putmeData",
		"jupebData",
		"partTimeData",
		"directEntryData",
		"menuItemsData",
		"impersonatorDetails",
		"impersonatorDetails",
		"supplementaryData",
		"firstYearHostelData"
	]
};

const rootReducer = combineReducers({
	sample: sampleReducer,
	studentData: createStudentReducer,
	pgData: pgReducer,
	firstYearHostelData: firstYearHostelReducer,
	putmeData: putmeReducer,
	directEntryData: directEntryReducer,
	jupebData: jupebReducer,
	partTimeData: partTimeReducer,
	menuItemsData: menuItemsReducer,
	impersonatorDetails: impersonatorReducer,
	supplementaryData: supplementaryReducer
});

export default persistReducer(persistConfig, rootReducer);
